import {styled} from '@mui/material/styles';
import * as React from 'react';
import {GridRenderCellParams} from "@mui/x-data-grid";
import Box from "@mui/material/Box";


interface ProgressProps {
    value: number;
}

const Element = styled('div')(({theme}) => ({
    border: `1px solid ${(theme.vars || theme).palette.divider}`,
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 26,
    borderRadius: 2,
}));

const Value = styled('div')({
    position: 'absolute',
    lineHeight: '24px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
});

const Bar = styled('div')({
    height: '100%',
    '&.low': {
        backgroundColor: '#f44336',
    },
    '&.medium': {
        backgroundColor: '#efbb5aa3',
    },
    '&.high': {
        backgroundColor: '#088208a3',
    },
});

const Progress = React.memo(function Progress(props: ProgressProps) {
    const {value} = props;
    const valueInPercent = value;
    let className = ""
    if (valueInPercent < 30) {
        className = 'low'
    } else if (valueInPercent >= 30 && valueInPercent <= 70) {
        className = 'medium'
    } else if (valueInPercent > 70) {
        className = 'high'
    }
    return (
        <Element>
            <Value>{`${valueInPercent.toLocaleString()} %`}</Value>
            <Bar
                className={className}
                style={{maxWidth: `${valueInPercent}%`}}
            />
        </Element>
    );
});

export function ProgressBar(params: GridRenderCellParams<any, number, any>) {
    if (params.value == null) {
        return '';
    }

    // If the aggregated value does not have the same unit as the other cell
    // Then we fall back to the default rendering based on `valueGetter` instead of rendering a progress bar.
    // if (params.aggregation && !params.aggregation.hasCellUnit) {
    //     return null;
    // }

    return (
        <Box height={'100%'} display={'flex'} component={'div'} alignItems={'center'}>
            <Progress value={params.value}/>
        </Box>
    );
}